import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import { connect } from 'react-redux'
import { Dimmer, Dropdown, Loader, Modal, Table } from 'semantic-ui-react'
import { getWidgetCountries } from '../actions/settings'
import close from '../assets/images/close.png'
import CountryData from '../helpers/data/countryCode.json'
import CommonButtons from './CommonButtons'
import { CommonNotify } from './CommonNotify'
import countries from '../lib/Country'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const CountryModal = ({
    open,
    isModalClose,
    leadData,
    getWidgetCountries,
    widgetCountries,
    phone_number,
    subscription
}) => {
    const [allowedCountries, setAllowedCountries] = useState([])
    const [agentList, setAgentList] = useState([])
    const [loader, setLoader] = useState(false)
    const [sendMsgData, setSendMsgData] = useState({
        lead_id: leadData?.id,
        from: null,
        to: leadData?.phone_number
    })

    useEffect(() => {
        getAgentList()
    }, [])

    const getAgentList = async () => {
        setLoader(true)
        const url = `${process.env.REACT_APP_BASE_APP_URL}/api/v1/team/members`
        await Axios.get(url)
            .then(res => {
                if (res?.data?.data) {
                    setLoader(false)
                    setAgentList([res?.data?.data?.admin, ...res?.data?.data?.members] || [])
                }
            })
            .catch(error => {
                setLoader(false)
            })
    }

    useEffect(() => {
        if (sendMsgData?.close === true) {
            isModalClose()
            setSendMsgData({
                ...sendMsgData,
                close: false
            })
        }
    }, [sendMsgData])

    useEffect(() => {
        resetWidgetCountries(widgetCountries?.data?.allowed_countries)
    }, [widgetCountries])

    useEffect(() => {
        if (!open) return
        if (allowedCountries.length) return

        getWidgetCountries()
    }, [open])

    const resetWidgetCountries = countries => {
        const allCountry = CountryData
        const allowed = allCountry
            .filter(item => {
                if (countries?.includes(item.name)) {
                    return item
                }
            })
            .map(item => item.code.toLowerCase())

        setAllowedCountries(allowed)
    }



    const contryCode = value => {
        let values = ''
        const count = value.length - 10
        values = value?.substring(0, count)
        if (value?.substring(0, 1) !== '+') {
            values = '+' + values
        }
        return values
    }
    return (
        <Modal
            className="send-message-modal"
            onClose={isModalClose}
            closeIcon
            open={open}
            size="tiny"
        >
            <Dimmer active={loader}>
                <Loader />
            </Dimmer>
            <div className="modal-header align-items-center">
                <h3 className="mx-auto mb-0">You can make calls/text to following countries</h3>
                <div className="close-icon" onClick={() => isModalClose(false)}>
                    <img src={close} alt="close" />
                </div>
            </div>
            <Modal.Content style={{ padding: '30px' }}>
                <div className='d-flex'>
                    <div>
                        <h6>Outgoing Countries</h6>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Country Code</Table.HeaderCell>
                                    <Table.HeaderCell>Country</Table.HeaderCell>

                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {subscription?.outgoing_white_list_countries?.map(option => (
                                    <Table.Row>
                                        <Table.Cell>
                                            {option}
                                        </Table.Cell><Table.Cell>
                                            {countries?.filter((obj) => obj?.code === option)?.[0]?.name}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                    <div>
                        <h6>Countries</h6>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Country Code</Table.HeaderCell>
                                    <Table.HeaderCell>Country</Table.HeaderCell>

                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {subscription?.white_list_countries?.map(option => (
                                    <Table.Row>
                                        <Table.Cell>
                                            {option}
                                        </Table.Cell><Table.Cell>
                                            {countries?.filter((obj) => obj?.code === option)?.[0]?.name}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                </div>

                <Link to='https://limecall.com/support'>To request any country not available on this list, please contact support</Link>
            </Modal.Content>
            <Modal.Actions className="send-message__btn">

            </Modal.Actions>
        </Modal>
    )
}

const mapStateToProps = state => {
    return {
        subscription: state.home.subscription?.data,
    }
}

export default connect(mapStateToProps, { getWidgetCountries })(CountryModal)
